{
  "name": "ticket-scanner",
  "displayName": "TicketScanner",
  "version": "0.8.1",
  "keywords": [
    "ecosystem:pwa"
  ],
  "author": "Timot Tarjani",
  "main": "index.js",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test-with-report": "ng test --browsers ChromeHeadless --watch=false --reporters=junit",
    "pwa": "ng build && http-server -p 8000 -c-1 dist/ticket-scanner",
    "i18n:init": "ngx-translate-extract --input ./src --output ./src/assets/i18n/template.json --key-as-default-value --replace --format json",
    "i18n:extract": "ngx-translate-extract --input ./src --output ./src/assets/i18n/en.json --clean --format json",
    "lint": "ng lint",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org web-entity --project ticket-scanner ./www && sentry-cli sourcemaps upload --org web-entity --project ticket-scanner ./www"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~19.2.5",
    "@angular/common": "~19.2.5",
    "@angular/compiler": "~19.2.5",
    "@angular/core": "~19.2.5",
    "@angular/forms": "~19.2.5",
    "@angular/localize": "^19.2.5",
    "@angular/platform-browser": "~19.2.5",
    "@angular/platform-browser-dynamic": "~19.2.5",
    "@angular/router": "~19.2.5",
    "@angular/service-worker": "~19.2.5",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@sentry/angular": "^8.13.0",
    "@sentry/cli": "^2.32.1",
    "@sentry/tracing": "^7.114.0",
    "@smartnowx/hcms-commons": "^0.0.36",
    "@smartnowx/hcms-plugin-event-manager": "^0.0.22",
    "@tailwindcss/postcss": "^4.1.10",
    "@zxing/ngx-scanner": "^18.0.0",
    "angular-device-information": "^4.0.0",
    "bootstrap": "^5.3.3",
    "bootstrap-icons": "^1.11.3",
    "dexie": "^3.2.4",
    "ngx-online-status": "^2.0.0",
    "ngx-spinner": "^19.0.0",
    "postcss": "^8.5.6",
    "rxjs": "~7.8.1",
    "tailwindcss": "^4.1.10",
    "tslib": "^2.6.3",
    "uuid": "^11.1.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~19.2.6",
    "@angular-eslint/builder": "18.0.1",
    "@angular-eslint/eslint-plugin": "18.0.1",
    "@angular-eslint/eslint-plugin-template": "18.0.1",
    "@angular-eslint/schematics": "18.0.1",
    "@angular-eslint/template-parser": "18.0.1",
    "@angular/cli": "~19.2.6",
    "@angular/compiler-cli": "~19.2.5",
    "@biesbjerg/ngx-translate-extract": "^7.0.4",
    "@types/jasmine": "~5.1.4",
    "@types/node": "^20.14.9",
    "@typescript-eslint/eslint-plugin": "^7.14.1",
    "@typescript-eslint/parser": "^7.14.1",
    "eslint": "^9.5.0",
    "jasmine-core": "~5.1.2",
    "karma": "~6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "typescript": "5.8.3"
  }
}
